import CustomerProfileSortMenu from './CustomerProfileSortMenu'

export default CustomerProfileSortMenu
